import type { AdministrativeCenterType } from '#shared/types/dbTypes/appTypes/usersTypes'

export const useLoginStore = defineStore('login', () => {
  //State
  const tokenExpires = ref<string | Date | null>(null)
  const userEmail = ref<string | null>(null)
  const lastVisit = ref<string | Date | null>(null)
  const userActiveCenters = ref<AdministrativeCenterType[] | null>(null)

  //Getters

  //Actions

  type UpdateLoginStorePayload = {
    'userEmail': string | null
    'expires': string | Date
    'lastVisit': string | Date
    'userActiveCenters': AdministrativeCenterType[]
  }

  async function updateUserLoginData(payload: UpdateLoginStorePayload) {
    console.log("LoginStore, payload :>> ")
    userEmail.value = payload.userEmail
    tokenExpires.value = payload.expires
    lastVisit.value = payload.lastVisit
    userActiveCenters.value = payload.userActiveCenters
  }

  return {
    tokenExpires,
    userEmail,
    lastVisit,
    userActiveCenters,
    updateUserLoginData
  }
})
